eshopApp.controller('PaymentMethodSelectorController', ['$scope', '$http', '$rootScope', function($scope, $http, $rootScope){

    $rootScope.m_PaymentMethodSelector = false;

    $scope.paymentmethod_success = false;
    $scope.spinner = false;
    $scope.selected_index = null;
    $scope.finalising = false;

    $scope.termsAccepted = false;

    // Set payment method
    $scope.setPaymentmethod = function(paymentmethod_id, index) {

        if ($scope.spinner === true) {
            return false;
        }

        $scope.spinner = true;
 
        $http.get('/a/set_paymentmethod/'+paymentmethod_id, function(){

        }).success(function(response){
            console.log('Payment', response);
            if(response.data === 'success') {
                $scope.selected_index = index;
                $scope.paymentmethod_success = true;
            }
        }).finally(function(){
            $scope.spinner = false;
        });

    }

    $scope.hideModule = function() {
        $rootScope.m_PaymentMethodSelector = false;
    }

    // Hide this module and show shipping method selector
    $scope.showShippingMethodSelector = function() {
        $rootScope.m_PaymentMethodSelector = false;
        $rootScope.m_ShippingMethodSelector = true;
    }
    
    // Hide stuff and show spinner while waiting for order to process
    $scope.finalize = function() {
        $rootScope.m_FullCart = false;
        $scope.finalizing = true;
    }
}]);